"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TagCloud = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TagCloud = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TagCloud, _Component);

  var _super = _createSuper(TagCloud);

  function TagCloud(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TagCloud);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      amount: props.amount
    };
    _this.onChangeAmount = _this.onChangeAmount.bind((0, _assertThisInitialized2.default)(_this));
    _this.notifyChanges = _this.notifyChanges.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TagCloud, [{
    key: "onChangeAmount",
    value: function onChangeAmount(newAmount) {
      this.setState({
        amount: newAmount
      }, this.notifyChanges);
    }
  }, {
    key: "notifyChanges",
    value: function notifyChanges() {
      this.props.onChange({
        amount: this.state.amount
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var amount = this.state.amount;
      return (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
        title: "Amount",
        type: "number",
        min: 0,
        onChange: function onChange(e) {
          _this2.onChangeAmount(parseInt(e.target.value));
        },
        value: amount
      }));
    }
  }]);
  return TagCloud;
}(_preact.Component);

exports.TagCloud = TagCloud;
var _default = TagCloud;
exports.default = _default;